import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Loader } from '@els/els-react--loader';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import QuickResultPredictButton from '@Pages/QuickSearch/Components/QuickResults/QuickResultPredictButton';

import PreviewResultsHeatmapButtonContainer from '@Containers/PreviewResultsHeatmapButton/PreviewResultsHeatmapButtonContainer';
import cn from 'classnames';

function BlockActionButtons({
  previewItem,
  showProgressLoader,
  onCancelClick,
  showQueryCancelled,
  showExpandButton,
  expandButtonConfig,
  expandButtonAttrs,
  expanded,
  toggleExpanded,
  showViewResultsButton,
  onViewResultsButtonClick,
  showPredictionButton,
  showBioactivityVisualizationButton,
}) {
  return (
    <div className="results-preview__block results-preview__block--action-buttons">
      {showProgressLoader && (
        <div className="results-preview__action-buttons-row">
          <Button type="link" size="small" className="u-els-color-link-inline u-els-margin-right-1x e2e-cancel" onClick={onCancelClick}>
            cancel progress
          </Button>
          <Loader
            isSmall
            isBlocking={false}
            isVisible
            className="results-preview__progress-loader e2e-progress-loader u-els-margin-left-1o2"
          />
        </div>
      )}

      {showQueryCancelled && (
        <div className="results-preview__action-buttons-row">
          <div className="showMore__cancelInfo">{`Search cancelled${get(previewItem, 'query.error') ? ' due to an error' : ''}`}</div>
        </div>
      )}

      <div className="results-preview__action-buttons-row">
        {showExpandButton && (
          <ButtonWithIcon
            type="transparent"
            sprite={expanded ? 'ChevronUp' : 'ChevronDown'}
            iconRight
            size="small"
            className={cn('u-els-color-link-inline', `e2e-${expandButtonConfig.e2eName}`)}
            onClick={toggleExpanded}
            aria-expanded={expanded}
            {...expandButtonAttrs}>
            {expandButtonConfig.label}
          </ButtonWithIcon>
        )}
        {showViewResultsButton && (
          <ButtonWithIcon
            type="tertiary"
            sprite="ChevronRight"
            iconRight
            className="e2e-view-results"
            onClick={onViewResultsButtonClick}
            aria-label={`View results from ${previewItem.databaseLabel}`}
            aria-describedby={previewItem.queryId}>
            View Results
          </ButtonWithIcon>
        )}
      </div>
      {showPredictionButton && <QuickResultPredictButton {...previewItem} />}
      {showBioactivityVisualizationButton && <PreviewResultsHeatmapButtonContainer {...previewItem} />}
    </div>
  );
}

BlockActionButtons.defaultProps = {
  onCancelClick: () => {},
  toggleExpanded: () => {},
  onViewResultsButtonClick: () => {},
};

BlockActionButtons.propTypes = {
  previewItem: PropTypes.object.isRequired,
  showProgressLoader: PropTypes.bool,
  onCancelClick: PropTypes.func,
  showQueryCancelled: PropTypes.bool,
  showExpandButton: PropTypes.bool,
  expandButtonConfig: PropTypes.object,
  expandButtonAttrs: PropTypes.object,
  expanded: PropTypes.bool,
  toggleExpanded: PropTypes.func,
  showViewResultsButton: PropTypes.bool,
  onViewResultsButtonClick: PropTypes.func,
  showPredictionButton: PropTypes.bool,
  showBioactivityVisualizationButton: PropTypes.bool,
};

export default BlockActionButtons;
